import { render } from "./BulkSetup.vue?vue&type=template&id=40fcce6e&scoped=true"
import script from "./BulkSetup.vue?vue&type=script&lang=js"
export * from "./BulkSetup.vue?vue&type=script&lang=js"

import "./BulkSetup.vue?vue&type=style&index=0&id=40fcce6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fcce6e"]])

export default __exports__